/* Draft theme promotion refresh: recommendations retain their required context. */
(() => {
 if(String(window.Shopify?.theme?.id)!=='194882765165'||window.shinyPromoExpiryStarted)return;
 window.shinyPromoExpiryStarted=true;
 const selector='[data-shiny-promo-slot][data-product-id]';let pending=false;
 function expire(){const now=Date.now()/1000;document.querySelectorAll('[data-shiny-promo-start][data-shiny-promo-end]').forEach(n=>{const a=Number(n.dataset.shinyPromoStart),b=Number(n.dataset.shinyPromoEnd);n.hidden=n.closest(selector)?.dataset.shinyPromoUnverified==='true'||!Number.isFinite(a)||!Number.isFinite(b)||now<a||now>=b;});}
 async function refresh(){
  if(pending||document.hidden)return;pending=true;let failed=false;
  try{
   const slots=[...document.querySelectorAll(selector)],sections=[...new Set(slots.map(n=>n.dataset.sectionId).filter(Boolean))];
   for(const section of sections){
    const targets=slots.filter(n=>n.dataset.sectionId===section);
    try{
     const rec=targets[0].closest('product-recommendations');
     const url=new URL(rec?.dataset.url||location.href,location.origin);
     if(url.origin!==location.origin)throw Error('REFRESH_ORIGIN_REJECTED');
     url.searchParams.delete('sections');
     if(rec){url.searchParams.set('section_id',section);url.searchParams.set('product_id',rec.dataset.productId);}
     else url.searchParams.set('sections',section);
     url.searchParams.set('_shiny_promo_refresh',String(Date.now()));
     const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
     if(!response.ok)throw Error('SECTION_REFRESH_FAILED');
     const html=rec?await response.text():(await response.json())[section];
     if(typeof html!=='string')throw Error('SECTION_DATA_MISSING');
     const doc=new DOMParser().parseFromString(html,'text/html'),incoming=[...doc.querySelectorAll(selector)];
     for(const target of targets){const next=incoming.find(n=>n.dataset.productId===target.dataset.productId);if(!next)throw Error('PRODUCT_SLOT_MISSING');}
     for(const target of targets){const next=incoming.find(n=>n.dataset.productId===target.dataset.productId);target.replaceChildren(...[...next.childNodes].map(n=>n.cloneNode(true)));delete target.dataset.shinyPromoUnverified;}
    }catch{failed=true;targets.forEach(n=>{n.dataset.shinyPromoUnverified='true';});}
   }
   document.documentElement.dataset.shinyPromoRefresh=failed?'failed':'ok';
  }finally{pending=false;expire();}
 }
 expire();setInterval(expire,1000);setInterval(refresh,60000);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden){expire();refresh();}});
 document.addEventListener('shopify:section:load',()=>{expire();refresh();});
})();